/**
 * @param {Object} featureViewModel
 * @constructor
 */
export function Feature(featureViewModel) {
    const keywordMatchFeatures = featureViewModel.keywordMatchFeatures || [];
    const remoteFeatures = featureViewModel.remoteFeatures || [];
    const bonusFeatures = featureViewModel.bonusFeatures || [];
    const immediatelyHiringFeatures = featureViewModel.immediatelyHiringFeatures || [];
    const normalFeatures = featureViewModel.normalFeatures || [];

    // KW一致特徴を分類する
    for (const keywordMatchFeature of keywordMatchFeatures) {
        if (keywordMatchFeature === 'Immediately Hiring') {
            immediatelyHiringFeatures.push(keywordMatchFeature);
        } else {
            normalFeatures.push(keywordMatchFeature);
        }
    }

    this.remoteFeatures = remoteFeatures;
    this.bonusFeatures = bonusFeatures;
    this.immediatelyHiringFeatures = immediatelyHiringFeatures;
    this.normalFeatures = normalFeatures;
}
